// extracted by mini-css-extract-plugin
module.exports = {"card":"CardTwo_card__3S_Zo","button":"CardTwo_button__PhhwR","image":"CardTwo_image__8g91a","bigHeader":"CardTwo_bigHeader__TZmbq"};